// extracted by mini-css-extract-plugin
module.exports = {"ces2023Page":"ces-2023_ces2023Page__6iSG2"};